"use client"

import { NotebookText } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `NotebookTextIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const NotebookTextIcon = component(Icon)({ as: NotebookText })
